import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NotificationService, PatronItemRequestService} from '@raven';
import {MatDialogRef} from '@angular/material/dialog';
import {BranchSelectors, OrganizationSelectors, PatronSelectors} from '@store/store.selectors';
import {STATE_SELECT} from '@store/common/common.types';
import {Store} from '@ngrx/store';
import {PatronActions} from '@store/patron/patron.actions';

@Component({
  selector: 'rn-submit-request',
  templateUrl: './submit-request.component.html',
  styleUrl: './submit-request.component.scss',
  standalone: false
})
export class SubmitRequestComponent implements OnInit {
  public readonly patronSelectors = PatronSelectors.Auth;
  public readonly branchSelectors = BranchSelectors.List;
  public readonly accountStatusSelectors = PatronSelectors.AccountStatus;
  public readonly organizationSelectors = OrganizationSelectors.Auth;
  requestForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<SubmitRequestComponent>,
    private patronItemRequestService: PatronItemRequestService,
    private notificationService: NotificationService,
    private router: Router,
    private fb: FormBuilder,
    private store: Store
  ) {
  }

  ngOnInit(): void {
    this.requestForm = this.fb.group({
      itemTitle: ['', {validators: [Validators.required]}],
      author: ['', {validators: [Validators.required]}],
      isbn: ['', {validators: []}],
      pickupLocation: [null, {validators: [Validators.required]}],
      materialTypeDesc: ['', {validators: []}],
      notes: ['', {validators: []}],
      agreeToPolicies: [false, {validators: [Validators.requiredTrue]}],
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  submit(): void {
    const v = this.requestForm.value;
    this.patronItemRequestService.submitItemRequest(
      v.itemTitle,
      v.author,
      v.pickupLocation,
      v.notes,
      v.isbn,
      v.materialTypeDesc
    ).subscribe((_) => {
      this.notificationService.showSnackbarSuccess('Request submitted successfully.');
      this.store.dispatch(PatronActions.loadAccountStatus());
    });
  }

  protected readonly STATE_SELECT = STATE_SELECT;
}
